var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 9.00007C3.25 8.58585 3.58579 8.25007 4 8.25007H20C20.4142 8.25007 20.75 8.58585 20.75 9.00007C20.75 9.41428 20.4142 9.75007 20 9.75007H4C3.58579 9.75007 3.25 9.41428 3.25 9.00007Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 15.0001C3.25 14.5859 3.58579 14.2501 4 14.2501H20C20.4142 14.2501 20.75 14.5859 20.75 15.0001C20.75 15.4143 20.4142 15.7501 20 15.7501H4C3.58579 15.7501 3.25 15.4143 3.25 15.0001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0828 2.25465C10.4945 2.3004 10.7912 2.67121 10.7454 3.08289L8.74541 21.0829C8.69967 21.4946 8.32886 21.7912 7.91718 21.7455C7.5055 21.6997 7.20884 21.3289 7.25459 20.9172L9.25459 2.91724C9.30033 2.50556 9.67114 2.20891 10.0828 2.25465Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0828 2.25465C16.4945 2.3004 16.7912 2.67121 16.7454 3.08289L14.7454 21.0829C14.6997 21.4946 14.3289 21.7912 13.9172 21.7455C13.5055 21.6997 13.2088 21.3289 13.2546 20.9172L15.2546 2.91724C15.3003 2.50556 15.6711 2.20891 16.0828 2.25465Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/Hash.c3ecfb30a8b646d87623b4645285fee3.svg";
export { ForwardRef as ReactComponent };